(function (global, factory) {
  if (typeof define === "function" && define.amd) {
    define(['exports', 'react', '../styles/colors'], factory);
  } else if (typeof exports !== "undefined") {
    factory(exports, require('react'), require('../styles/colors'));
  } else {
    var mod = {
      exports: {}
    };
    factory(mod.exports, global.react, global.colors);
    global.ApproverFlyer = mod.exports;
  }
})(this, function (exports, _react, _colors) {
  'use strict';

  Object.defineProperty(exports, "__esModule", {
    value: true
  });

  var _react2 = _interopRequireDefault(_react);

  var _colors2 = _interopRequireDefault(_colors);

  function _interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
      default: obj
    };
  }

  var ApproverFlyer = function ApproverFlyer(_ref) {
    var size = _ref.size,
        color = _ref.color;
    return _react2.default.createElement(
      'svg',
      {
        xmlns: 'http://www.w3.org/2000/svg',
        xmlnsXlink: 'http://www.w3.org/1999/xlink',
        width: size,
        height: size,
        viewBox: '0 0 24 24',
        fill: color
      },
      _react2.default.createElement(
        'defs',
        null,
        _react2.default.createElement('path', {
          id: 'a',
          d: 'M22.209 8.5l-7.164 4.375L7.88 8.5V6.75l7.164 4.375 7.164-4.375V8.5zM7.881 5c-.985 0-1.875.787-1.875 1.75v.875H0v1.75h6.006v1.75H.896v1.75h5.11v1.75h-3.32v1.75h3.32v.875c0 .962.89 1.75 1.875 1.75h14.328c.985 0 1.791-.788 1.791-1.75V6.75C24 5.787 23.194 5 22.209 5H7.881z'
        })
      ),
      _react2.default.createElement(
        'g',
        { fillRule: 'evenodd' },
        _react2.default.createElement(
          'mask',
          { id: 'b', fill: '#fff' },
          _react2.default.createElement('use', { xlinkHref: '#a' })
        ),
        _react2.default.createElement('use', { xlinkHref: '#a' }),
        _react2.default.createElement(
          'g',
          { mask: 'url(#b)' },
          _react2.default.createElement('path', { d: 'M-78-53h180V77H-78z' })
        )
      )
    );
  };

  exports.default = ApproverFlyer;
});


//////////////////
// WEBPACK FOOTER
// ./node_modules/@peachjar/components/build/svg/ApproverFlyer.js
// module id = 510
// module chunks = 0